import HomepageController from './homepage/HomepageController';

new HomepageController();